import {useEffect, useRef} from "react";

export function useInterval(callback: () => void, intervalMs: number) {
    const intervalRef = useRef<number>();
    const stableCallbackRef = useRef(callback);

    stableCallbackRef.current = callback;

    useEffect(() => {
        intervalRef.current = setInterval(() => stableCallbackRef.current(), intervalMs) as any;

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [intervalMs]);
}
